import React, { useState, useEffect } from 'react';
// 🔥 1. هنستورد أدوات الراوتر
import { 
  BrowserRouter as Router, 
  Routes, 
  Route, 
  Navigate,
  useSearchParams
} from 'react-router-dom';
import { auth, db } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';

// 🔥 2. هنستورد كل الصفحات
import LoginPage from './LoginPage';
import ClientDashboard from './ClientDashboard';
import SignupPage from './SignupPage'; // الصفحة الجديدة
import './App.css';

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔥 3. الكود بتاعك زي ما هو (ممتاز)
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // 🔥 5. كود التحميل
  if (loading) {
    return <div style={{ textAlign: 'center', fontSize: '24px', marginTop: '100px' }}>جاري التحميل...</div>;
  }

  // 🔥 6. ده الراوتر الجديد (بديل الـ if القديمة)
  return (
    <Router>
      <Routes>
        {/* --- المسارات العامة (للي مش مسجل دخول) --- */}
        
        <Route 
          path="/" 
          element={
            !currentUser ? <LoginPage /> : <Navigate to="/dashboard" replace />
          } 
        />
        <Route 
          path="/signup" 
          element={
            !currentUser ? <SignupPage /> : <Navigate to="/dashboard" replace />
          } 
        />

        {/* --- المسارات المحمية (للي مسجل دخول) --- */}
        
        <Route 
          path="/dashboard" 
          element={<DashboardWrapperWithAuth currentUser={currentUser} />} 
        />

        {/* لو كتب أي رابط غلط، رجعه للبداية */}
        <Route path="*" element={<Navigate to="/" replace />} />
        
      </Routes>
    </Router>
  );
}

// Wrapper يتحقق لو Super Admin ولا عميل عادي
function DashboardWrapperWithAuth({ currentUser }) {
  const [searchParams] = useSearchParams();
  const adminUidFromUrl = searchParams.get('admin');
  
  // لو في admin في الـ URL، يبقى Super Admin مش محتاج Protected Route
  if (adminUidFromUrl) {
    return <DashboardWrapper user={null} />;
  }
  
  // لو مفيش admin، يبقى عميل عادي لازم يكون مسجل دخول
  if (!currentUser) {
    return <Navigate to="/" replace />;
  }
  
  return <DashboardWrapper user={currentUser} />;
}

// Wrapper للـ Dashboard عشان يقرأ الـ uid من الـ URL
function DashboardWrapper({ user }) {
  const [searchParams] = useSearchParams();
  const clientUidFromUrl = searchParams.get('uid');
  const adminUidFromUrl = searchParams.get('admin');
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [checkingAdmin, setCheckingAdmin] = useState(true);
  const [superAdminUser, setSuperAdminUser] = useState(null);
  
  useEffect(() => {
    // لو في uid و admin في الـ URL، نتأكد إن الـ admin UID صحيح
    const checkSuperAdmin = async () => {
      if (clientUidFromUrl && adminUidFromUrl) {
        try {
          // نتأكد إن الـ admin UID موجود في super_admins
          const superAdminsQuery = query(
            collection(db, 'super_admins'), 
            where('auth_uid', '==', adminUidFromUrl)
          );
          const snapshot = await getDocs(superAdminsQuery);
          
          if (!snapshot.empty) {
            console.log('✅ Super Admin verified with UID:', adminUidFromUrl);
            setIsSuperAdmin(true);
            // نحفظ بيانات الـ Super Admin
            setSuperAdminUser({
              uid: adminUidFromUrl,
              email: snapshot.docs[0].data().email,
              name: snapshot.docs[0].data().name
            });
          } else {
            console.log('❌ Invalid admin UID:', adminUidFromUrl);
            setIsSuperAdmin(false);
          }
        } catch (error) {
          console.error('Error checking super admin:', error);
          setIsSuperAdmin(false);
        }
      } else if (user) {
        // لو مفيش uid في الـ URL، يبقى عميل عادي مسجل دخول
        setIsSuperAdmin(true);
      } else {
        // لو مفيش admin ولا user، يرجع للـ login
        setIsSuperAdmin(false);
      }
      setCheckingAdmin(false);
    };
    
    checkSuperAdmin();
  }, [clientUidFromUrl, adminUidFromUrl, user]);
  
  // لو لسه بيتشيك
  if (checkingAdmin) {
    return (
      <div style={{ textAlign: 'center', fontSize: '24px', marginTop: '100px', color: '#bd93f9' }}>
        🔐 جاري التحقق من الصلاحيات...
      </div>
    );
  }
  
  // لو في client UID بس مفيش admin صحيح
  if (clientUidFromUrl && adminUidFromUrl && !isSuperAdmin) {
    return (
      <div style={{ 
        textAlign: 'center', 
        fontSize: '24px', 
        marginTop: '100px', 
        color: '#ff5555',
        padding: '40px'
      }}>
        <h2>🚫 غير مصرح بالدخول</h2>
        <p style={{ fontSize: '18px', color: '#f8f8f2' }}>
          ليس لديك صلاحية لعرض dashboard عملاء آخرين.
        </p>
        <button 
          onClick={() => window.location.href = '/dashboard'}
          style={{
            background: '#bd93f9',
            color: '#282a36',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '16px',
            marginTop: '20px'
          }}
        >
          الذهاب إلى Dashboard الخاص بك
        </button>
      </div>
    );
  }

  return <ClientDashboard user={user || superAdminUser} viewingClientUid={clientUidFromUrl} isSuperAdminView={!!adminUidFromUrl} />;
}

export default App;